import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

export type WorkingHoursChangeForm = {
  newWorkingHours: string;
  startYearMonth: string;
};

const defaultValues: WorkingHoursChangeForm = {
  newWorkingHours: '',
  startYearMonth: '',
};

const useWorkingHoursChangeForm = () => {
  const { t } = useTranslation();

  const Schema = Yup.object().shape({
    newWorkingHours: Yup.string().required(
      t('변경할 근무 시간을 선택해주세요.'),
    ),
    startYearMonth: Yup.string().required(
      t('근무 시간 변경 시작 월을 선택해주세요.'),
    ),
  });

  return useForm<WorkingHoursChangeForm>({
    resolver: yupResolver(Schema),
    defaultValues,
    mode: 'onChange',
  });
};

export default useWorkingHoursChangeForm;
